/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameStartPrompt.vue?vue&type=template&id=790727cf&scoped=true"
import script from "./popGameStartPrompt.vue?vue&type=script&lang=js"
export * from "./popGameStartPrompt.vue?vue&type=script&lang=js"
import style0 from "./popGameStartPrompt.vue?vue&type=style&index=0&id=790727cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790727cf",
  null
  
)

export default component.exports